import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const updatedSalaryDateSlice = createSlice({
  name: "startDate",

  initialState: {
    start_date: "",
    paymentMethod: "",
  },
  reducers: {
    setSalaryStartDate: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.start_date = payload;
    },

    resetSalaryDate: (state: any) => {
      state.start_date = "";
    },
    setPaymentMethod: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.paymentMethod = payload;
    },

    resetPaymentMethod: (state: any) => {
      state.paymentMethod = "";
    },
  },
});

export const {
  setSalaryStartDate,
  resetSalaryDate,
  resetPaymentMethod,
  setPaymentMethod,
} = updatedSalaryDateSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default updatedSalaryDateSlice.reducer;
